import api from '@/utils/api';

const state = {
    isAuthLoaded: false,
    isLoading: true,
    menuGroups: [],
    companyInfo: {
        sno: null,
        cH_CMP: '',
        cH_ADR: '',
        eN_CMP: '',
        eN_ADR: '',
        tel: '',
        fax: '',
        email: '',
        bnK_BOO: '',
        bnK_DOO: '',
        bnK_ACC: '',
        bnK_NAM: '',
        eN_BNK_NAM: '',
        swifT_CODE: '',
        logo: '',
        color: '',
        iniT_FIN: '',
    },
    memberInfo: {
        sno: null,
        cmp: '',
        pdT_TYP: '',
        orD_NO: null,
        taX_BOO: '',
        bsn: '',
        onf: null,
        sdt: '',
        edt: '',
    },
};
const getters = {
    isAuthLoaded: (state) => state.isAuthLoaded,
    menuGroups: (state) => state.menuGroups,
    companyInfo: (state) => state.companyInfo,
    memberInfo: (state) => state.memberInfo,
    isTrying: (state) => state.memberInfo.onfnam === '試用中',
    isLoading: (state) => state.isLoading,
};
const actions = {
    updateMenu({ commit }) {
        state.isLoading = true;
        return new Promise((resolve, reject) => {
            api({ url: 'Layout/GetMenus', data: null, method: 'GET' })
                .then((resp) => {
                    commit('update_menu', {
                        menuGroups: resp.data.menuGroups,
                        companyInfo: resp.data.companyInfo,
                        memberInfo: resp.data.memberInfo,
                    });
                    state.isLoading = false;
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    logoutMenu({ commit }) {
        commit('logout', null);
    },
};
const mutations = {
    update_menu(state, { menuGroups, companyInfo, memberInfo }) {
        state.menuGroups = menuGroups;
        state.companyInfo = companyInfo;
        state.memberInfo = memberInfo;
        state.isAuthLoaded = true;
    },
    logout(state) {
        state.menuGroups = [];
        state.isAuthLoaded = false;
        state.companyInfo = {
            sno: null,
            cH_CMP: '',
            cH_ADR: '',
            eN_CMP: '',
            eN_ADR: '',
            tel: '',
            fax: '',
            email: '',
            bnK_BOO: '',
            bnK_DOO: '',
            bnK_ACC: '',
            bnK_NAM: '',
            eN_BNK_NAM: '',
            swifT_CODE: '',
            logo: '',
            color: '',
            iniT_FIN: '',
        };
        state.memberInfo = {
            sno: null,
            cmp: '',
            pdT_TYP: '',
            orD_NO: '',
            taX_BOO: '',
            bsn: '',
            onf: null,
            sdt: '',
            edt: '',
        };
    },
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
